import { atom } from "recoil";

export const HiddenAddClickState = atom({
    key: "HiddenAddClickState",
    default: false,
});